import React from "react"
import Dropdown from "../../../../Dropdown/Dropdown"
import { options } from "./options"
import { setQuestionType } from "../../useReducer/actionCreators"
import useOption from "./useOption"

const QuestionTypeDropdown = ({ externalDispatch, selectedType }) => {
  const [option, setOption] = useOption(selectedType)
  return (
    <Dropdown
      label="Question Type"
      id="question_type_dropdown"
      options={options}
      value={option}
      onChange={(option) => {
        setOption(option)
        externalDispatch(setQuestionType(option.id))
      }}
    />
  )
}
export default QuestionTypeDropdown
